import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";

export interface CheckboxRadioGroupProps<T> {
  options: T[];
  value: T | undefined;
  onChange: (a: T | undefined) => void;
  renderOption: (a: T) => string;
  disabled?: boolean;
  row?: boolean;
}

export function CheckboxRadioGroup<A extends string>(props: CheckboxRadioGroupProps<A>): React.ReactElement {
  return (
    <>
      {props.options.map((opt) => (
        <FormControlLabel
          className="h-6"
          disabled={props.disabled}
          key={opt}
          control={
            <Checkbox
              size="small"
              color="default"
              checked={props.value === opt}
              onChange={(event) => {
                if (event.target.checked) {
                  props.onChange(opt);
                } else {
                  props.onChange(undefined);
                }
              }}
            />
          }
          label={props.renderOption(opt)}
        />
      ))}
    </>
  );
}

export default CheckboxRadioGroup;
